import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrandHubPageService_GetHeaderV2Lazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.grpc.lazy';
import {useCurrentPageType, useIsMultiBrand} from '@aboutyou/router';
import {useTargetGroupIdentifier} from '../../../../shared-deprecated/useTargetGroupIdentifier';
import {
  useBrandShopCacheKeyTransformer,
  useBrandShopIdentifier,
} from '../../utils/useBrandShopIdentifier';
import {useCategoryIdentifier} from '../../utils/useCategoryIdentifier';

export const useGetBrandPageHeader = () => {
  const brandIdentifier = useBrandShopIdentifier();
  const targetGroup = useTargetGroupIdentifier();
  const isMultiBrand = useIsMultiBrand();
  const brandShopCacheKeyTransformer = useBrandShopCacheKeyTransformer();
  const category = useCategoryIdentifier();
  const currentPageType = useCurrentPageType();

  const categoryProp = currentPageType === 'brandShop' ? category : null;

  return useGrpcRequest(
    BrandHubPageService_GetHeaderV2Lazy,
    {
      brand: {
        identifier: brandIdentifier,
      },
      targetGroup,
      isMultiBrand,
      category: categoryProp ?? null,
    },
    {
      keepPreviousData: true,
      transformCacheKey: brandShopCacheKeyTransformer,
    },
  );
};
